// extracted by mini-css-extract-plugin
module.exports = {"pieChartContainer":"pieChartAndLabels_pieChartContainer__1cMwn","pieChart":"pieChartAndLabels_pieChart__3WMCE"};